module.exports = "<svg id=\"621e9748-164f-4276-9097-99a548614df3\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><path d=\"M25,0C16,0,8.9,7.23,8.9,17a20.77,20.77,0,0,0,1.32,6.36C14.7,33.73,18.22,39.62,25,50c6.87-10.86,10.67-16.36,15.16-26.63A20.78,20.78,0,0,0,41.1,17C41.1,7.23,33.94,0,25,0Zm-.11,27.54c-5.35,0-9.69-4.65-9.69-10.39s4.34-10.4,9.69-10.4,9.69,4.66,9.69,10.4S30.21,27.54,24.86,27.54Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = 563
// module chunks = 1